import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class AddQuestionService {
    constructor(private http: HttpClient) { }

    create(question:any) {
        let user: any ;
        if (localStorage.getItem('currentUserId')) {
            user = JSON.parse(localStorage.getItem('currentUserId'));
        }
        var data = {team: user.team ,question: question};
        return this.http.post(URL+'pss_app/add-question/', data);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/add-question.service.ts